import React from "react";
import { useI18n } from "@/i18n/I18nContext";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import SafeMailLink from "@/components/layout/SafeMailLink";
import SEO from "@/components/seo/SEO";

export default function Legal() {
  const { language } = useI18n();
  const fr = (
    <div className="prose prose-sm max-w-none text-foreground">
      <h1 className="font-heading text-2xl font-medium">Mentions légales</h1>
      <h2 className="mt-6 font-heading text-lg font-medium">Éditeur du site</h2>
      <p className="mt-2 text-muted-foreground">
        Le site Kalypso Music (kalypsomusic.com) est édité par <strong>Marc BARBIER</strong>, Entreprise Individuelle,
        immatriculée en France sous le numéro SIREN <strong>837 746 700</strong>.<br/>
        Contact : <SafeMailLink email="contactkalypsomusic@gmail.com" className="text-primary" />
      </p>
      <h2 className="mt-6 font-heading text-lg font-medium">Hébergement</h2>
      <p className="mt-2 text-muted-foreground">Le site est hébergé sur une infrastructure cloud sécurisée.</p>
      <p className="mt-4 text-muted-foreground">Kalypso Music est un service de génération musicale par intelligence artificielle. Toutes les paroles et compositions sont générées automatiquement et sont 100% originales.</p>
      <h2 className="mt-6 font-heading text-lg font-medium">Propriété intellectuelle</h2>
      <p className="mt-2 text-muted-foreground">Les créations sont libres de droits pour un usage personnel. Aucune ressemblance avec des artistes existants n'est intentionnelle ni autorisée.</p>
      <h2 className="mt-6 font-heading text-lg font-medium">Données personnelles</h2>
      <p className="mt-2 text-muted-foreground">Vos données sont stockées de manière sécurisée et ne sont jamais revendues à des tiers. Voir notre <a href="/confidentialite" className="text-primary">politique de confidentialité</a>.</p>
      <h2 className="mt-6 font-heading text-lg font-medium">Stockage des fichiers</h2>
      <p className="mt-2 text-muted-foreground">Vos créations sont conservées gratuitement pendant 1 mois à compter de leur génération.</p>
    </div>
  );
  const en = (
    <div className="prose prose-sm max-w-none text-foreground">
      <h1 className="font-heading text-2xl font-medium">Legal Notice</h1>
      <h2 className="mt-6 font-heading text-lg font-medium">Site publisher</h2>
      <p className="mt-2 text-muted-foreground">
        The Kalypso Music site (kalypsomusic.com) is published by <strong>Marc BARBIER</strong>, sole proprietorship,
        registered in France under SIREN number <strong>837 746 700</strong>.<br/>
        Contact: <SafeMailLink email="contactkalypsomusic@gmail.com" className="text-primary" />
      </p>
      <h2 className="mt-6 font-heading text-lg font-medium">Hosting</h2>
      <p className="mt-2 text-muted-foreground">The site is hosted on secure cloud infrastructure.</p>
      <p className="mt-4 text-muted-foreground">Kalypso Music is an AI music generation service. All lyrics and compositions are automatically generated and 100% original.</p>
      <h2 className="mt-6 font-heading text-lg font-medium">Intellectual Property</h2>
      <p className="mt-2 text-muted-foreground">Creations are royalty-free for personal use. Any resemblance to existing artists is unintentional and not authorized.</p>
      <h2 className="mt-6 font-heading text-lg font-medium">Personal Data</h2>
      <p className="mt-2 text-muted-foreground">Your data is stored securely and never resold to third parties. See our <a href="/confidentialite" className="text-primary">privacy policy</a>.</p>
      <h2 className="mt-6 font-heading text-lg font-medium">File Storage</h2>
      <p className="mt-2 text-muted-foreground">Your creations are kept free of charge for 1 month from their generation.</p>
    </div>
  );

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <SEO title={language === "en" ? "Legal Notice | Kalypso Music" : "Mentions légales | Kalypso Music"} description={language === "en" ? "Legal notice of Kalypso Music, the AI personalized song platform (kalypsomusic.com)." : "Mentions légales de Kalypso Music, la plateforme de chansons personnalisées par IA (kalypsomusic.com)."} path="/mentions-legales" />
      <main className="mx-auto max-w-3xl px-4 py-16 sm:px-6">{language === "en" ? en : fr}</main>
      <Footer />
    </div>
  );
}
